import { render } from "./5.OurMission.vue?vue&type=template&id=70884f3e&scoped=true"
import script from "./5.OurMission.vue?vue&type=script&lang=js"
export * from "./5.OurMission.vue?vue&type=script&lang=js"

import "./5.OurMission.vue?vue&type=style&index=0&id=70884f3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70884f3e"]])

export default __exports__